import { motion } from 'framer-motion';
import { Heart, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/i18n/LanguageContext';

interface SoftEncouragementProps {
  show: boolean;
  onDismiss: () => void;
}

export function SoftEncouragement({ show, onDismiss }: SoftEncouragementProps) {
  const { t } = useLanguage();
  
  if (!show) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <Card className="border-primary/20 bg-gradient-to-br from-primary/5 to-transparent">
        <CardContent className="p-6 text-center">
          <div className="inline-flex p-3 rounded-full bg-primary/10 mb-4">
            <Heart className="h-6 w-6 text-primary" />
          </div>

          <p className="text-lg text-foreground/80 mb-4">
            {t.howToUse.gamification.softEncouragement.message}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/create">
              <Button className="gap-2">
                <Plus className="h-4 w-4" />
                {t.howToUse.gamification.softEncouragement.cta}
              </Button>
            </Link>
            <Button variant="ghost" onClick={onDismiss} className="text-muted-foreground">
              {t.howToUse.gamification.softEncouragement.dismiss}
            </Button>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
